export const DisplayType = {
    Shop: { value: 0, label: 'Shop' },
    Popup: { value: 1, label: 'Popup' },
    Event: { value: 2, label: 'Event' },
    AccessUnlimited: { value: 3, label: 'AccessUnlimited' }
};

export const FilterType = {
    NoFilter: { label: 'No filter', value: 0 },
    Status: { label: 'Status', value: 1 },
    Persona: { label: 'Persona', value: 2 }
};

export const FilterStatus = {
    All: { label: 'All', value: -1 },
    None: { label: 'None', value: 0, background: 'info' },
    Enabled: { label: 'Enabled', value: 1, background: 'success' },
    Started: { label: 'Started', value: 2, background: 'success' },
    Stopped: { label: 'Stopped', value: 3, background: 'warning' },
    Disabled: { label: 'Disabled', value: 4, background: 'danger' },
    AccessUnlimited: { label: 'AccessUnlimited', value: 5, background: 'info' }
};

export const Options = {
    Status: Object.entries(FilterStatus).map(([, data]) => data),
    DisplayType: Object.entries(DisplayType).map(([, data]) => data),
    FilterType: Object.entries(FilterType).map(([, data]) => data)
};
